import {TimePickerProps} from '../components/time-picker';

export const getTimePicker =
  <T>(data: Omit<TimePickerProps<T>, 'type'>) =>
  (): TimePickerProps<T> => ({
    ...data,
    type: 'time-picker',
  });
